import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=1dc3c4dd&"
import script from "./KanbanBoard.vue?vue&type=script&lang=js&"
export * from "./KanbanBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports